import { render, staticRenderFns } from "./password_account.vue?vue&type=template&id=11336718&"
import script from "./password_account.vue?vue&type=script&lang=js&"
export * from "./password_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports